import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-order-closure-detail-dialog',
  templateUrl: './order-closure-detail-dialog.component.html',
  styleUrls: ['./order-closure-detail-dialog.component.scss']
})
export class OrderClosureDetailDialogComponent implements OnInit {
  dropLabel: any = [];
  heading: string;
  constructor(
    public matDialogRef: MatDialogRef<OrderClosureDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
  ) {
    this.heading = _data.heading;
  }

  ngOnInit(): void {
    this._data.dropPoints.forEach((element, i) => {
      let temp;
      console.log("element", element);
      if (element.isCancelled == 1 || element.isReturned == 1) {
        temp = `${element.name} ${element.orderClosurePrice}`
      } else if (element.isCancelled == 0 && element.isReturned == 0 && element.isDelivered == 0 && element.status == 1) {
        temp = `${element.name} ${element.orderClosurePrice}`
      } else {
        temp = `${element.name} ${element.payToCustomer}`
      }
      this.dropLabel.push(temp)
    });
    this.dropLabel = this.dropLabel.join(', + ');
  }

  getDropLabel(item){
    const { isDelivered, isCancelled, isReturned, payToCustomer, orderClosurePrice } = item;
    if (isDelivered == 1) {
      if (isCancelled == 1 || isReturned == 1) { return `${orderClosurePrice || 0}` }
      return `${payToCustomer || 0}`
    }
    return `${orderClosurePrice || 0}`
  };

}
